import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { PromoCodeProtocol, PromoCodeProtocolType } from './promo-code-protocol.js';
import { Price } from '../price.js';

export class PercentagePromoCodeProtocol extends PromoCodeProtocol {
  static readonly TYPE_ID: string = 'e7fa8cfc09204106be3f271526b6414f';

  public readonly type: PromoCodeProtocolType = PromoCodeProtocolType.Percentage;

  constructor(
    public readonly discount: number,
  ) {
    super();
  }

  get $typeId(): string {
    return PercentagePromoCodeProtocol.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PercentagePromoCodeProtocol {
    return new PercentagePromoCodeProtocol(
        MapUtils.get<number>(map, 'discount'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'discount': this.discount,
    };
  }

  clone(): this {
    return new PercentagePromoCodeProtocol(
        this.discount,
    ) as this;
  }

  isSame(other: PercentagePromoCodeProtocol): boolean {
    if(this === other) {
      return true;
    }

    return other.discount == this.discount;
  }

  calculateDiscount(originalPrice: Price): Price {
    const sanitizedDiscount = Math.max(0, Math.min(100, this.discount));
    const discountPercents = sanitizedDiscount / 100.0;

    return originalPrice.scale(discountPercents);
  }

  static verifyType(dm: DataModel): boolean {
    return dm instanceof PercentagePromoCodeProtocol;
  }

  static assertType(dm: DataModel): dm is PercentagePromoCodeProtocol {
    return dm instanceof PercentagePromoCodeProtocol;
  }
}

export class PercentagePromoCodeProtocolBuilder extends DataModelBuilder<PercentagePromoCodeProtocol> {
  build(context: SerializationContext, map: SerializedData): PercentagePromoCodeProtocol {
    return PercentagePromoCodeProtocol.fromMap(context, map);
  }
}
